export  const descriptionRegex = (descr: string) => {
    const h2FirstResult = descr.replace(/<h2>/g, '');
    const h2FinalResult = h2FirstResult.replace(/<\/h2>/g, ' ');

    const pFirstResult = h2FinalResult.replace(/<p>/g, '');
    const pFinalResult = pFirstResult.replace(/<\/p>/g, '');

    const aFirstresult = pFinalResult.replace(/<a.*?">/g, '');
    const finalResult = aFirstresult.replace(/<\/a>/g, '');


    return finalResult;
}